import INotificationsRepository from 'domain/interfaces/repositories/INotificationsRepository'
import { Query } from 'domain/models/query'

export const readNotificationsQuery = (repository: INotificationsRepository, query?: Query) => {
  return repository.getNotifications(query)
}
